<template>
  <v-sheet flat>
    <v-data-table
      :items-per-page="5"
      :items="fileData"
      :headers="headers"
      hide-default-header
    >
      <template #header="{ props: { headers } }">
        <thead class="v-data-table-header">
          <th
            v-for="header in headers"
            :key="header.text"
            style="padding-right: 2px"
          >
            <v-menu max-width="300px">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="grey darken-1"
                  elevation="0"
                  v-bind="attrs"
                  block
                  v-on="on"
                  :style="`position: relative; color: white; ${
                    buttonText(header.value)
                      ? ''
                      : 'font-style: itailc; opacity: .7; font-size: .6em;'
                  }`"
                >
                  {{ buttonText(header.value) || "(нет)" }}

                  <v-icon
                    style="
                      position: absolute;
                      right: -18px;
                      top: 50%;
                      transform: translateY(-50%);
                      opacity: 0.4;
                    "
                  >
                    mdi-chevron-down
                  </v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  v-for="item in selectionItems"
                  :key="item.val"
                  class="d-flex flex-grow-0"
                  @click="changeCol(item.val, header.value)"
                >
                  <v-list-item-title
                    :class="item.val == null ? 'red--text' : ''"
                  >
                    {{ item.text }}
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </th>
        </thead>
      </template>
      <template v-slot:item="{ item }">
        <tr>
          <td v-for="header in headers" :key="header.text">
            <v-tooltip
              v-if="item[header.text] == false && item[header.text] !== '0'"
              color="warning"
              top
            >
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on" style="color: orange"> 0 </span>
              </template>
              <span>
                Значение отсутсвует в файле. <br />
                Подставлено значение по умолчанию
              </span>
            </v-tooltip>
            <span v-else> {{ item[header.text] }} </span>
          </td>
        </tr>
      </template>
      <template #top>
        <v-fade-transition>
          <v-card-text v-if="!allOk" class="red--text">
            {{ defaultColumnsOk ? "" : "Не заполнены обязательные колонки. " }}
            {{ caloryOk ? "" : "Не заполнены колонки калорийности. " }}
            {{ amountsOk ? "" : "Не заполнены колонки остатков. " }}
            {{
              precentlesOk ? "" : "Не заполнены колонки процентов обработки. "
            }}
          </v-card-text>
        </v-fade-transition>
      </template>
    </v-data-table>
  </v-sheet>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data: () => ({
    menuItems: [
      { text: "Код", val: "code" },
      { text: "Путь по группам", val: "path" },
      { text: "Название товара", val: "name" },
      { text: "Ед. Измерения", val: "unitName" },
      { text: "Белки", val: "proteins" },
      { text: "Жиры", val: "fats" },
      { text: "Углеводы", val: "carbs" },
      { text: "% холодной обработки", val: "precentle1" },
      { text: "% горячей обработки", val: "precentle2" },
      { text: "Мин", val: "min" },
      { text: "Макс", val: "max" },
    ],
  }),
  computed: {
    ...mapGetters([
      "uploadOptions",
      "fileData",
      "fileColumns",
      "columns",
      "defaultColumnsOk",
      "caloryOk",
      "amountsOk",
      "precentlesOk",
    ]),
    headers() {
      let hlst = [];
      for (let i = 0; i < this.fileColumns; i++) {
        hlst.push({
          text: i,
          value: `${i}`,
        });
      }
      return hlst;
    },
    selectionItems() {
      let items = [];
      for (const menuItem of this.menuItems) {
        if (
          (!this.uploadOptions.uploadCals &&
            (menuItem.val == "carbs" ||
              menuItem.val == "fats" ||
              menuItem.val == "proteins")) ||
          (!this.uploadOptions.uploadPrecent &&
            (menuItem.val == "precentle1" || menuItem.val == "precentle2")) ||
          (!this.uploadOptions.uploadMinMaxAmounts &&
            (menuItem.val == "min" || menuItem.val == "max"))
        )
          continue;
        if (this.columns[menuItem.val] == null) items.push(menuItem);
      }
      items.push({ text: "Очистить поле", val: null });
      return items;
    },
    allOk() {
      return (
        this.defaultColumnsOk &&
        this.caloryOk &&
        this.precentlesOk &&
        this.amountsOk
      );
    },
  },
  methods: {
    ...mapActions(["updateColumn"]),
    count(val) {
      return this.used.filter((e) => e == val).length;
    },
    changeCol(key, idx) {
      for (const colKey in this.columns) {
        if (this.columns[colKey] == idx)
          this.updateColumn({ key: colKey, val: null });
      }
      if (key != null) {
        this.updateColumn({ key, val: parseInt(idx) });
      } else {
        this.updateColumn({ key, val: null });
      }
    },
    buttonText(idx) {
      for (const colKey in this.columns) {
        if (this.columns[colKey] == idx) {
          let found = this.menuItems.find((item) => item.val == colKey);
          return found ? found.text : null;
        }
      }
      return null;
    },
  },
};
</script>

<style scoped>
</style>